import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";

export default function Header() {
  const [open, setOpen] = useState(false);
  const { lang, setLang } = useLanguage();
  const text = translations[lang].header;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-screen-2xl mx-auto px-6 py-4 flex items-center justify-between">

        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img
            src="/logo5.png"
            alt="HelvetAssist"
            className="h-8 w-auto object-contain"
          />
          <div className="text-gray-800 font-semibold">
            HelvetAssist
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex gap-8 items-center text-gray-700 font-medium">
          <Link to="/" className="hover:text-red-600">{text.home}</Link>
          <Link to="/about" className="hover:text-red-600">{text.about}</Link>
          <Link to="/services" className="hover:text-red-600">{text.services}</Link>
          <Link to="/contact" className="hover:text-red-600">{text.contact}</Link>

          {/* Language Switch */}
          <div className="flex gap-2 ml-6">
            {["fr", "en", "de"].map(l => (
              <button
                key={l}
                onClick={() => setLang(l)}
                className={`px-3 py-1 text-sm rounded border
                  ${lang === l ? "bg-black text-white" : "border-gray-300 text-gray-700"}`}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>

          {/* WhatsApp Desktop */}
          <a
            href="https://wa.me/41767070557"
            target="_blank"
            rel="noopener noreferrer"
            className="transition hover:scale-110"
          >
            <img src="/whatsapp.svg" alt="WhatsApp" className="h-5 w-5" />
          </a>

          {/* Instagram Desktop */}
          <a
            href="https://www.instagram.com/helvet.assist/"
            target="_blank"
            rel="noopener noreferrer"
            className="transition hover:scale-110 ml-[2px]"
          >
            <img src="/instagram.svg" alt="Instagram" className="h-5 w-5" />
          </a>
        </nav>

        {/* Mobile Right Side */}
        <div className="flex items-center gap-4 md:hidden">

          {/* WhatsApp Mobile */}
          <a
            href="https://wa.me/41767070557"
            target="_blank"
            rel="noopener noreferrer"
            className="transition hover:scale-110"
          >
            <img src="/whatsapp.svg" alt="WhatsApp" className="h-6 w-6" />
          </a>

          {/* Instagram Mobile */}
          <a
            href="https://www.instagram.com/helvet.assist/"
            target="_blank"
            rel="noopener noreferrer"
            className="transition hover:scale-110 ml-[2px]"
          >
            <img src="/instagram.svg" alt="Instagram" className="h-6 w-6" />
          </a>

          {/* Hamburger */}
          <button onClick={() => setOpen(!open)}>
            {open ? <X size={28} /> : <Menu size={28} />}
          </button>

        </div>
      </div>

      {/* Mobile Dropdown */}
      {open && (
        <div className="md:hidden px-6 pt-4 pb-4 bg-white shadow-inner flex flex-col gap-3 text-gray-700">
          <Link to="/" onClick={() => setOpen(false)}>{text.home}</Link>
          <Link to="/about" onClick={() => setOpen(false)}>{text.about}</Link>
          <Link to="/services" onClick={() => setOpen(false)}>{text.services}</Link>
          <Link to="/contact" onClick={() => setOpen(false)}>{text.contact}</Link>

          {/* Language Switch Mobile */}
          <div className="flex gap-2 mt-3">
            {["fr", "en", "de"].map(l => (
              <button
                key={l}
                onClick={() => setLang(l)}
                className={`px-3 py-1 text-sm rounded border
                  ${lang === l ? "bg-black text-white" : "border-gray-300 text-gray-700"}`}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}